module.exports = __webpack_public_path__ + "img/sprite-24.fe4a7caa.png";